import React from "react";
import { CheckCircle2, Circle, Play, FileText, HelpCircle, Video } from "lucide-react";

const TYPE_ICON = { video: Video, text: FileText, quiz: HelpCircle, live: Play };

export default function ProgramaSidebar({ modules, progress, activeLessonId, onSelect }) {
  return (
    <aside className="lg:col-span-1 space-y-4" data-testid="lesson-sidebar" aria-label="Módulos y lecciones del programa">
      {modules.map((m) => (
        <div key={m.id} className="border border-gray-800 rounded-lg bg-[#111827] overflow-hidden">
          <div className="px-3 py-2 border-b border-gray-800">
            <p className="text-[10px] uppercase tracking-widest text-gray-500">Módulo {m.order}</p>
            <p className="text-sm font-semibold text-white leading-tight">{m.title}</p>
          </div>
          <div>
            {m.lessons.map((l) => {
              const state = progress.lesson_states[l.id];
              const active = l.id === activeLessonId;
              const Icon = TYPE_ICON[l.type] || FileText;
              return (
                <button
                  key={l.id}
                  onClick={() => onSelect(l.id)}
                  data-testid={`lesson-item-${l.id}`}
                  aria-current={active ? "true" : undefined}
                  aria-label={`Lección: ${l.title}. ${state === "completed" ? "Completada" : "Pendiente"}`}
                  className={`w-full text-left px-3 py-2 flex items-start gap-2 text-sm transition-colors border-l-2 ${
                    active ? "bg-white/5 text-white border-l-[#3B82F6]" : "text-gray-400 hover:bg-white/[0.03] border-l-transparent"
                  }`}
                >
                  {state === "completed"
                    ? <CheckCircle2 className="w-4 h-4 text-emerald-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
                    : <Circle className="w-4 h-4 text-gray-600 flex-shrink-0 mt-0.5" aria-hidden="true" />}
                  <div className="flex-1 min-w-0">
                    <p className="truncate">{l.title}</p>
                    <p className="text-[10px] text-gray-500 uppercase flex items-center gap-1 mt-0.5">
                      <Icon className="w-3 h-3" aria-hidden="true" /> {l.type} · {l.duration_min} min
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </aside>
  );
}
